import { getIp } from '../../helpers/ip';

export const sendAcceptanceLog = async (
  rgpdSettings: Record<string, boolean>
) => {
  try {
    const ip = await getIp();
    await fetch('/api/logs/acceptance', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        message: `ip ${ip} changed rgpd settings to ${JSON.stringify(
          rgpdSettings
        )}`,
      }),
    });
  } catch (err) {
    throw new Error(`unable to send acceptance log : ${err}`);
  }
};
